import config from '../config';
import STATES from '../us-states';
import fetchJSON from '../../utils/fetch/fetchJSON';
import memoize from '../../utils/fp/memoize';

/**
 * @public
 * Gets the geolocation information through the client IP.
 *
 * @returns {Promise}
 */
function getLocationByIp() {
  return fetchJSON({
    url: config.geoIp,
    method: 'GET',
  })
    .then(geoIp => (STATES.find(s => s.Abbr === geoIp.region_code) ? geoIp : {}));
}

export default memoize(getLocationByIp);
